import React from "react";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import VisibilityIcon from "@material-ui/icons/Visibility";
import StatusChip from "./StatusChip";

const useStyles = makeStyles((theme) => ({
  // نکته‌ی اصلی رفع اسکرول موبایل همینجاست:
  // overflow: "hidden" جلوی اسکرول افقی را می‌گیرد؛ باید overflowX: "auto" باشد
  // تا وقتی جدول از عرض صفحه بیشتر شد، به‌جای فشرده‌شدن ستون‌ها، اسکرول بخورد.
  paper: {
    width: "100%",
    overflowX: "auto",
    WebkitOverflowScrolling: "touch", // اسکرول نرم روی iOS/سافاری
  },
  // با تعیین min-width برای جدول، مرورگر مجبور می‌شود به‌جای فشرده کردن
  // ستون‌ها در صفحه‌های کوچک، اسکرول افقی نمایش دهد.
  table: {
    minWidth: 650,
  },
  headerCell: {
    fontWeight: 700,
    backgroundColor: theme.palette.grey[50],
    whiteSpace: "nowrap",
  },
  cell: {
    whiteSpace: "nowrap",
  },
  row: {
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  rowSelected: {
    backgroundColor: theme.palette.action.selected,
  },
  viewButton: {
    borderColor: theme.palette.grey[300],
    color: theme.palette.primary.main,
    whiteSpace: "nowrap",
  },
  viewButtonActive: {
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
    whiteSpace: "nowrap",
  },
}));

// فرمت تاریخ و ساعت به شمسی برای مقدار created_at
function formatJalaliDateTime(createdAt) {
  const date = new Date(createdAt);
  const datePart = new Intl.DateTimeFormat("fa-IR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
  const timePart = new Intl.DateTimeFormat("fa-IR", {
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
  return `${datePart} - ${timePart}`;
}

// جدول اصلی نمایش درخواست‌های احراز هویت کاربران
export default function RequestsTable({
  requests,
  closeModal,
  onViewDetails,
  selectedId,
}) {
  const classes = useStyles();

  return (
    <TableContainer
      component={Paper}
      elevation={0}
      variant="outlined"
      className={classes.paper}
    >
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell align="center" className={classes.headerCell}>
              ردیف
            </TableCell>
            <TableCell align="right" className={classes.headerCell}>
              نام و نام خانوادگی
            </TableCell>
            <TableCell align="right" className={classes.headerCell}>
              تلفن
            </TableCell>
            <TableCell align="right" className={classes.headerCell}>
              تاریخ درخواست
            </TableCell>
            <TableCell align="center" className={classes.headerCell}>
              وضعیت
            </TableCell>
            <TableCell align="center" className={classes.headerCell}>
              عملیات
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {requests.map((request, index) => {
            const isSelected = selectedId === request.id;
            return (
              <TableRow
                key={request.id}
                className={`${classes.row} ${
                  isSelected ? classes.rowSelected : ""
                }`}
                hover
                selected={isSelected}
              >
                <TableCell align="center" className={classes.cell}>
                  {index + 1}
                </TableCell>
                <TableCell align="right" className={classes.cell}>
                  {request.full_name}
                </TableCell>
                <TableCell align="right" className={classes.cell}>
                  {request.cell}
                </TableCell>
                <TableCell align="right" dir="ltr" className={classes.cell}>
                  {formatJalaliDateTime(request.updated_at)}
                </TableCell>
                <TableCell align="center" className={classes.cell}>
                  <StatusChip status={request.is_verified} />
                </TableCell>
                <TableCell align="center" className={classes.cell}>
                  <Button
                    size="small"
                    variant="outlined"
                    className={
                      isSelected ? classes.viewButtonActive : classes.viewButton
                    }
                    startIcon={
                      <VisibilityIcon fontSize="small" style={{ margin: 4 }} />
                    }
                    onClick={() =>
                      isSelected ? closeModal() : onViewDetails(request)
                    }
                  >
                    {isSelected ? "بستن جزئیات" : "مشاهده جزئیات"}
                  </Button>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
